var React = require('react');

function IconEnvelopeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.8906 2.39062H2.10938C0.946266 2.39062 0 3.33689 0 4.5V13.5C0 14.6631 0.946266 15.6094 2.10938 15.6094H15.8906C17.0537 15.6094 18 14.6631 18 13.5V4.5C18 3.33689 17.0537 2.39062 15.8906 2.39062ZM16.5938 13.5C16.5938 13.8877 16.2783 14.2031 15.8906 14.2031H2.10938C1.72167 14.2031 1.40625 13.8877 1.40625 13.5V4.5C1.40625 4.1123 1.72167 3.79688 2.10938 3.79688H15.8906C16.2783 3.79688 16.5938 4.1123 16.5938 4.5V13.5Z","fill":"white","key":0}),React.createElement("path",{"d":"M16.4743 3.2673L8.99999 8.82679L1.52563 3.2673L0.68631 4.39564L8.99999 10.5794L17.3137 4.39564L16.4743 3.2673Z","fill":"white","key":1})]);
}

IconEnvelopeInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IconEnvelopeInline;

IconEnvelopeInline.default = IconEnvelopeInline;
